import type { TriggerSchedule } from '@/types/custom-playbooks';

export type PollMinutes = NonNullable<TriggerSchedule['everyMinutes']>;

/** The intervals a continuous play checks on (the API's `everyMinutes`). */
export const POLL_MINUTES: readonly PollMinutes[] = [1, 2, 5, 10, 15, 30];

/** A continuous schedule's interval: its `everyMinutes`, else 30. */
export function pollMinutes(
  schedule: TriggerSchedule | null | undefined
): PollMinutes {
  const n = schedule?.everyMinutes;
  return POLL_MINUTES.find((m) => m === n) ?? 30;
}

/** "Every minute", "Every 5 minutes". */
export function pollMinutesWords(minutes: number): string {
  return minutes === 1 ? 'Every minute' : `Every ${minutes} minutes`;
}
